'use client';

import { useState } from 'react';

import { Accordion, AccordionDetails, AccordionProps, AccordionSummary, Box, Icon, Typography } from '@mui/material';
import cx from 'clsx';

import ChevronDown from '@/components/SvgIcons/ChevronDown';
import { Accordion as AccordionType } from '@/types/accordion.type';

import styles from './AccordionMenuItem.module.scss';

interface AccordionMenuItemProps
  extends Omit<AccordionProps, 'children' | 'title' | 'content' | 'variant'>, AccordionType {
  defaultExpanded?: boolean;
}

const AccordionMenuItem = ({ title, content, defaultExpanded = false, ...accordionProps }: AccordionMenuItemProps) => {
  const [expanded, handleChange] = useState(defaultExpanded);

  const handleToogle = () => {
    handleChange(prev => !prev);
  };

  return (
    <Accordion
      {...accordionProps}
      classes={{ root: styles.root }}
      className={cx(styles.container, { [styles.expanded]: expanded })}
      expanded={expanded}
      onChange={handleToogle}
      component="div"
    >
      <AccordionSummary
        className={styles.summary}
        expandIcon={
          <Icon className={styles.arrowWrapper}>
            <ChevronDown size={24} props={{ className: styles.arrow }} />
          </Icon>
        }
      >
        <Typography variant="subtitle1" component="h3" className={styles.title}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: content! }}
          className={styles.body}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionMenuItem;
